import { messageUrl } from "../resources";
import postRequest from '../common/postRequest';

async function createMessage(data, token) {

    let url = `${messageUrl}/SendMessage`;

    return await postRequest.postDataWithToken(url, data, token);
}

async function createMessagePrintPage(data, token) {
    let url = `${messageUrl}/SendMessageToPrinter`;

    return await postRequest.postDataWithToken(url, data, token);
}

export default {
    createMessage,
    createMessagePrintPage
}

